<template>
	<Modal @close="$emit('close')" size="large">
		<div class="container">
			<div class="row">
				<div class="col-12">
					<h3>{{horse.name}} History</h3>
				</div>
			</div>
			<div class="row">
				<div class="col-6">
					<router-link target="_blank" :to="params" class="button-action">Print</router-link>
				</div>
			</div>
			<p id="noHistory" v-if="!horseHistory.length">No history found</p>
			<table v-if="horseHistory.length" class="item-table history-table">
				<thead>
					<tr class="item-headers">
						<th>
							<div class="bar bg-blue">
								<h3>Date</h3>
							</div>
						</th>
						<th>
							<div class="bar bg-brown">
								<h3>Name</h3>
							</div> 
						</th>
						<th>
							<div class="bar bg-brown">
								<h3>Lot</h3>
							</div> 
						</th>
						<th>
							<div class="bar bg-brown">
								<h3>Tasks</h3>
							</div> 
						</th>
					</tr>
				</thead>

				<tbody>
					<tr v-for="(history, index) in horseHistory" :key="index">
						<td>{{ formatDate(history.date.split('T')[0]) }}</td>
						<td>{{history.name ? history.name : ''}}</td>
						<td>{{history.lot_num ? history.lot_num : ''}}</td>
						<td>{{history.tasks}}</td>
					</tr>
				</tbody>
			</table>

		</div>
	</Modal>
</template>

<script>
import { mapState } from 'vuex'
import Modal from './../Modal.vue'
import moment from 'moment'

import history from '../../lib/history';

export default {
	components: {
		Modal,
	},
	data() {
		return {
			horseHistory: {},
			params: '/print/horse'
		}
	},
	props: [
		'horse'
	],
	methods: {
		print() {
			window.print();
		},
		formatDate(date) {
			return moment(date).format('DD/MM/YYYY')
		}
	},
	mounted() {
		this.params = this.params + `/${this.$props.horse.name}` + `/${this.$props.horse.id}`
		this.$store.commit('app/setLoading', true)
		
		history.horse(this.$props.horse.id)
		.then(res => {
			this.$store.commit('app/setLoading', false);
			this.horseHistory = res
		})
		.catch(err => {
			this.$store.commit('app/setLoading', false);
			this.$store.dispatch('app/addAlert', {
				type: 'error',
				message: 'An Error occurred, please try later',
				timeout: 3000
			})
		})
	}
}
</script>

<style lang="scss">
@import '../../scss/variables.scss';
#noHistory {
	color: $error_color;
	font-weight: 600;
}
.history-table {
	tr {
		h3 {
			color: white !important;
			font-weight: bold !important;
			font-size: 18px !important;
		}
	}
}
</style>


// WEBPACK FOOTER //
// src/components/Horses/History.vue